<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Tambah Penggajian'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'payrolls'"
              :isEdit="false"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import Form from '@/component/payrolls/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  data() {
    return {
      form: {
        employee_id: '',
        remuneration_id: [],
        paid_date: '',
        payment_method: '',
        ammount:"",
        quantity:[],
        remuneration_type_name:[],
        remuneration_ammount:[],
        remuneration_notes:[],

      },
    };
  },

  components: {
    Card,
    Form
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Penggajian", route: "" },
      { title: "Daftar Penggajian", route: "/payrolls/list" },
      { title: "Tambah" },
    ])
  },

}

</script>